import * as type from "../types/new-space";

const initialState = {
  organizationNumber: null,
  trialPeriod: null,
  environmentId: null,
  createNew: {
    status: null,
    loading: false,
    error: null,
  },
  checkoutData: {
    organizationNumber: null,
    environmentId: null,
    trialEligible: false,
    checkoutId: null,
  },
};

export const newSpace = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_VALIDATE_NEW_SPACE:
      return {
        ...state,
        checkoutData: {
          ...state.checkoutData,
          organizationNumber: null,
          trialEligible: false,
        },
        createNew: {
          ...state.listSize,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_VALIDATE_NEW_SPACE:
      return {
        ...state,
        checkoutData: {
          ...state.checkoutData,
          organizationNumber: null,
          trialEligible: false,
        },
        createNew: {
          ...state.listSize,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_VALIDATE_NEW_SPACE:
      return {
        ...state,
        checkoutData: {
          ...state.checkoutData,
          organizationNumber: payload.data.organizationNumber,
          checkoutId: payload.data.checkoutId,
          trialEligible: payload.data.trialEligible,
        },
        createNew: {
          ...state.listSize,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_VALIDATE_NEW_SPACE:
      return {
        ...state,
        checkoutData: {
          ...state.checkoutData,
          checkoutId: null,
        },
        createNew: {
          ...state.listSize,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
